module.exports = __webpack_public_path__ + "static/media/pohon3.ae18f34d.png";